module.exports = __webpack_public_path__ + "static/img/niudao-ky.b0d03bd5.png";